










































































































































































































































import moment from 'moment';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY as PARENT_STORE_KEY } from '../../ShiftVDP/_store';
import { STORE_KEY, store } from './_store';

import IncidentCombobox from '@/components/Controls/IncidentCombobox.vue';
import Attachments from '@/components/Controls/Attachments.vue';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(PARENT_STORE_KEY, [
      'prevDocumentId'
    ]),
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta',
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  components: {
    IncidentCombobox,
    Attachments
  },
  validations() {
    const rules: any = {
      shift_id: { required },
      plan_id: { required },
      datetime: { required },
      moment: {  },
      termocamera: {  },
      direct_palete: { },
      row_number: { },
      bucket_number: { },
      temp: { required },
      acidity: { required },
      fat_id: {  },
      elasticity_id: {  },
      causticity_id: {  },
      characteristic_id: {  },
      gas_formation: {  },
      incident_type_id: {  },
      incident_sub_type_id: {  },
    }

    return {
      form: rules
    }
  }
})
export default class ShiftClotsForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;
  @Prop({ type: String }) documentId!: any;
  @Prop({ type: String }) prevDocumentId!: any;
  @Prop() volumeType!: string;


  document!: any
  form!: any
  prevPlansList!: any
  starter_type_code: any = 't'

  termocameras: any[] = [
    {id: 1, label: '1'},
    {id: 2, label: '2'},
    {id: 3, label: '3'},
  ]

  tanks: any[] = [
    {id: 1, label: '1'},
  ]
  directs: any[] = [
    {id: 'up', label: 'верх'},
    {id: 'dowm', label: 'низ'},
  ]
  docIds: any[] = [];

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  get newDay(){
    return moment().hours()  < 9;
  }

  public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
    this.setDocIds()
  }

  @Watch('prevDocumentId')
  setDocIds() {
    this.docIds = [this.documentId]
    if (this.prevDocumentId) {
      this.docIds.push(this.prevDocumentId);
      
    }
  }

  addAttachments(file: any) {
    this.$store.dispatch(`${STORE_KEY}/addAttachments`, {newValue: file});
  }

  removeFile( idx: number, data: any) {
    this.form.attachments.splice(idx, 1)
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    // this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  onContainerChange($event: any) {
    if ($event && $event.label) {
      this.changeValue('container_weight', $event.weight);
      this.changeValue('container_tare_weight', $event.tare_weight);
    }
  }

  onPlanDVP($event: any) {
    if ($event && $event.label) {
      this.changeValue('starter_type_code', $event.starter_type_code);
    }
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

